<template>
    <div class="feedback-submit">
        <HeaderNav
            header-title="提交反馈信息"
            left-icon-name=""
            right-icon-name=""
        ></HeaderNav>
        <div class="main-wrapper">
            <div class="message-wrapper">
                <p class="title">
                    <i class="iconfont icondingdan"></i>基础信息
                </p>
                <ul class="msg-wrapper">
                    <li class="msg-item">
                        <van-row type="flex" justify="space-between">
                            <van-col span="10">
                                <i class="title-1"></i><span class="msg-title ">供应单编号</span>
                            </van-col>
                            <van-col span="14">
                                <span class="msg-content">{{ formData.no }}</span>
                            </van-col>
                        </van-row>
                    </li>
                    <li class="msg-item">
                        <van-row type="flex" justify="space-between">
                            <van-col span="10">
                                <i class="title-2"></i><span class="msg-title">原材料类型</span>
                            </van-col>
                            <van-col span="14">
                                <span class="msg-content">{{ formData.type_name }}</span>
                            </van-col>
                        </van-row>
                    </li>
                    <li class="msg-item">
                        <van-row type="flex" justify="space-between">
                            <van-col span="10">
                                <i class="title-3"></i><span class="msg-title">原材料名称</span>
                            </van-col>
                            <van-col span="14">
                                <span class="msg-content">{{ formData.goods_name }}</span>
                            </van-col>
                        </van-row>
                    </li>
                    <li class="msg-item">
                        <van-row type="flex" justify="space-between">
                            <van-col span="10">
                                <i class="title-4"></i><span class="msg-title">供应量</span>
                            </van-col>
                            <van-col span="14">
                                <span class="msg-content">{{ formData.supply_count }}</span>
                            </van-col>
                        </van-row>
                    </li>
                    <li class="msg-item">
                        <van-row type="flex" justify="space-between">
                            <van-col span="10">
                                <i class="title-5"></i><span class="msg-title">供应时间</span>
                            </van-col>
                            <van-col span="14">
                                <span class="msg-content">{{ formData.supply_date }}</span>
                            </van-col>
                        </van-row>
                    </li>
                </ul>
            </div>
            <div class="driver-wrapper">
                <div class="driver-header-wrapper">
                    <van-row type="flex" justify="space-between">
                        <van-col span="16">
                            <p class="driver-msg">
                                <i class="iconfont iconshuiniche1"></i>进站车辆信息
                            </p>
                        </van-col>
                        <van-col span="8">
                            <span
                                v-if="formData.supplier_state !== 4 || formData.supplier_state !== 5"
                                class="driver-select"
                                @click="btnClick('driverList')"
                            >选择车辆 >></span>
                        </van-col>
                    </van-row>
                </div>
                <p class="warning">
                    注：务必输入司机和车辆信息，以免车辆无法入场
                </p>
                <ul class="driver-list-wrapper">
                    <van-checkbox-group v-model="result" @change="isSelect">
                        <template v-for="(item,index) in CarList">
                            <li class="driver-item" :key="index">
                                <van-checkbox :name="item.id" :disabled="item.balance_id">
                                    <div>
                                        <p>
                                            <van-col span="10">
                                                <i></i>
                                                <span class="driver-platenumber">{{ item.car_no }}</span>
                                            </van-col>
                                            <van-col span="8" class="transportStatus">
                                                <span style="color: #00A84B;" v-if="item.transport_status == 0">运输中</span>
                                            </van-col>
                                            <van-col span="6" v-if="!item.balance_id">
                                                <button class="delete" @click="deleteVehicle(item.id)">
                                                    删除
                                                </button>
                                            </van-col>
                                        </p>
                                        <p>
                                            <van-col span="6">
                                                <span class="driver-name">{{ item.driver_name }}</span>
                                            </van-col>
                                            <van-col span="10">
                                                <span class="driver-phone">{{ item.driver_phone }}</span>
                                            </van-col>
                                            <van-col span="8" class="unboundState" v-if="item.unboundState">
                                                解绑中...
                                            </van-col>
                                        </p>
                                    </div>
                                </van-checkbox>
                            </li>
                        </template>
                    </van-checkbox-group>
                </ul>
            </div>
            <div class="btn-wrapper">
                <div class="driver-radio van_left">
                    <input
                        type="checkbox"
                        name="name"
                        v-model="isSelectAll"
                    >
                    <label @click="selectAll()">
                        <i v-if="isSelectAll == false" class="iconfont iconunselect-radio2"></i>
                        <i v-if="isSelectAll == true" class="iconfont iconxuanzhong"></i>
                    </label>
                </div>
                <van-button
                    type="warning"
                    :disabled="result.length <= 0"
                    @click="vehicleUnbundling()"
                >
                    车辆解绑
                </van-button>
                <van-button
                    type="danger"
                    :disabled="result.length <= 0"
                    @click="batchDeleteVehicles()"
                >
                    删除
                </van-button>
            </div>
        </div>
        <span class="submit-btn" v-if="formData.supplier_state !== 4 || formData.supplier_state !== 5" @click="submitChange">提交</span>
        <span class="return-btn" @click="handleBack"><i class="iconfont ">&#xe607;</i></span>
    </div>
</template>

<script>
import { HeaderNav } from '@/components/';
import { Toast, Dialog } from 'vant';
export default {
    components: {
        HeaderNav,
    },
    data() {
        return {
            // 基础信息
            formData: {},
            // 车辆列表
            CarList: [],
            // 选择车辆
            result: [],
            // 是否全选
            isSelectAll: false,
        };
    },
    created() {
        this.formData = JSON.parse(this.$route.query.row);
        this.supplierCarList();
    },
    methods: {
        handleBack() {
            this.$router.isBack = 1;
            this.$router.push({ name: 'FeedbackList' });
        },
        submitChange() {
            Dialog.confirm({
                message: '确定要提交？',
            }).then(() => {
                Toast.loading({
                    message: '请求中...',
                    forbidClick: false,
                    loadingType: 'spinner',
                });
                const CheckedArr = [];
                this.CarList.forEach(item => {
                    CheckedArr.push(item.car_id);
                });
                this.$axios
                    .put('/interfaceApi/procurement/daily/supply/feedback', {
                        no: this.formData.no,
                        car_ids: CheckedArr,
                    })
                    .then(() => {
                        Toast.success({
                            message: '提交成功',
                            duration: 500,
                        });
                        setTimeout(() => {
                            this.$router.isBack = 1;
                            this.$router.push({ name: 'FeedbackList' });
                        }, 1000);
                    })
                    .catch(error => {
                        this.$toast('message:' + error.Errorcode.Message + '');
                    });
            }).catch(() => {
                // on cancel
            });
        },
        btnClick(name) {
            const CheckedArr = [];
            this.CarList.forEach( item => {
                CheckedArr.push(item.car_id);
            });
            this.$router.isBack = 2;
            this.$router.push({
                name: name,
                query: {
                    row: JSON.stringify(this.formData),
                    CheckedArr: JSON.stringify(CheckedArr),
                },
            });
        },
        // 全选按钮
        selectAll() {
            this.result = [];
            if (this.isSelectAll === false) {
                this.isSelectAll = true;
                this.CarList.forEach(item => {
                    this.result.push(item.id);
                });
            } else {
                this.isSelectAll = false;
            }
        },
        // 全选状态
        isSelect() {
            if (this.result.length !== this.CarList.length) {
                this.isSelectAll = false;
            } else {
                this.isSelectAll = true;
            }
        },
        // 删除车辆
        deleteVehicle(id) {
            const requestData = [];
            requestData.push(id);
            this.deleteVehicleRequest(requestData);
        },
        // 批量删除
        batchDeleteVehicles() {
            this.deleteVehicleRequest(this.result);
        },
        // 删除车辆请求
        deleteVehicleRequest(data) {
            this.$dialog.confirm({
                title: '删除',
                message: '确认删除？',
            })
                .then(() => {
                    this.$axios
                        .put(`/interfaceApi/procurement/daily/supply/truck/delete/${this.formData.id}/${data}`)
                        .then(res => {
                            this.$toast(res);
                            this.supplierCarList();
                        })
                        .catch(error => {
                            this.$dialog({ message: error.ErrorCode.Message });
                        });
                })
                .catch(() => {
                    this.$toast('取消删除！');
                });
        },
        // 解绑车辆请求
        vehicleUnbundling() {
            const carNo = [];
            let plate_numebrs = '';
            this.CarList.forEach(item => {
                if (this.result.indexOf(item.id) > -1 && item.transport_status === '0') {
                    carNo.push(item.car_no);
                }
            });
            if (carNo.length > 0) {
                plate_numebrs = carNo.toString();
                this.$dialog.confirm({
                    title: '车辆解绑',
                    message: '确认解绑？',
                })
                    .then(() => {
                        this.$axios
                            .put(`interfaceApi/wechat/carlocation/unbind_cars/${plate_numebrs}`)
                            .then(() => {
                                this.CarList.forEach(item => {
                                    if (carNo.indexOf(item.car_no) > -1) {
                                        item.unboundState = true;
                                    }
                                });
                                this.$toast('车辆解绑中!');

                            })
                            .catch(error => {
                                this.$dialog({ message: error.ErrorCode.Message });
                            });
                    })
                    .catch(() => {
                        this.$toast('取消解绑！');
                    });
            } else {
                this.$toast('请先选择运输中车辆！');
            }
        },
        // 拉取已选车辆
        supplierCarList() {
            this.$axios
                .get('/interfaceApi/procurement/daily/supply/get_supply_trucks/' + this.formData.no)
                .then(res => {
                    this.CarList = res;
                    if (this.CarList.length === 0) {
                        this.isSelectAll = false;
                    } else {
                        this.CarList.forEach(item => {
                        // 运输中车辆添加解绑状态
                            if (item.transport_status === 0) {
                                item.unboundState = false;
                            }
                        });
                    }
                })
                .catch(error => {
                    this.$toast('message:' + error.ErrorCode.Message + '');
                });
        },
    },
};
</script>

<style lang="stylus">
.feedback-submit
    padding-top 44rpx
    height calc(100% - 44rpx)
    background rgba(240,240,240,1)
    position relative
    .submit-btn
        position absolute
        top 15rpx
        right 15rpx
        color #fff
        font-size 14rpx
        z-index 999
    .return-btn
        position absolute
        top 11rpx
        left 15rpx
        color #fff
        font-size 10rpx
        z-index 999
    .main-wrapper
        height 100%
        padding-bottom 60rpx
        overflow-y auto
        overflow-x hidden
        .message-wrapper
            background #ffffff
            .title
                height 45rpx
                line-height 45rpx
                color #3495FB
                font-size 18rpx
                padding-left 15px
                border-bottom 2rpx solid rgba(240,240,240,1)
                i
                    margin-right 15rpx
            .msg-wrapper
                .msg-item
                    height 45rpx
                    line-height 45rpx
                    border-bottom 2rpx solid rgba(240,240,240,1)
                    .msg-title
                        margin-left 15rpx
                        // padding-left 15rpx
                        display block
                        // width 100%
                        font-size 16rpx
                    i
                        width: 16rpx
                        height 16rpx
                        background url(./../../assets/images/icons/icon_gy_1.png)
                        background-size 100% 100%
                        display inline-block
                        float left
                        margin 15rpx
                        &.title-2
                            background url(./../../assets/images/icons/icon_gy_3.png)
                            background-size 100% 100%
                        &.title-3
                            background url(./../../assets/images/icons/icon_34.png)
                            background-size 100% 100%
                        &.title-4
                            background url(./../../assets/images/icons/icon_30.png)
                            background-size 100% 100%
                        &.title-5
                            background url(./../../assets/images/icons/icon_gy_7.png)
                            background-size 100% 100%
                    .msg-content
                        display block
                        width 100%
                        text-align right
                        padding-right 15rpx
                        color #979EA7
                        font-size 14rpx
        .driver-wrapper
            background #ffffff
            margin-top 15rpx
            .warning
                width 100%
                height 30rpx
                line-height 30rpx
                background rgba(254,229,229,1)
                color #E60000
                text-align center
                font-size 12rpx
            .driver-header-wrapper
                width 100%
                height 45rpx
                line-height 45rpx
                color #3495FB
                .driver-msg
                    font-size 18rpx
                    padding-left 15rp
                    margin-left 15rpx
                    i
                        margin-right 15rpx
                        width 16rpx
                        height 16rpx
                        display inline-block
                        font-size 16rpx
                .driver-select
                    font-size 14rpx
                    text-align right
                    display block
                    margin-right 15rpx
            .driver-list-wrapper
                .driver-item
                    border-bottom 2rpx solid rgba(240,240,240,1)
                    padding 10rpx
                    overflow hidden
                    .van-checkbox__label
                        width 100%
                    p
                        height 18rpx
                        overflow hidden
                        &:nth-child(2)
                            margin-top 5rpx
                        i
                            width: 18rpx
                            height 18rpx
                            background url(./../../assets/images/icons/icon_gy_9.png)
                            background-size 100% 100%
                            display inline-block
                            float left
                            margin-top 2rpx
                        .transportStatus
                            span
                                font-size 14rpx
                    .delete
                        float right
                        font-size 14rpx
                        line-height 18rpx
                        border none
                        background #fff
                        color #E50000
                    .driver-platenumber
                        font-size 16rpx
                        margin-left 15rpx
                        line-height 18rpx
                    .driver-name
                        color #979EA7
                        font-size 14rpx
                    .driver-phone
                        text-align right
                        display block
                        color #979EA7
                        font-size 14rpx
                    .unboundState
                        color #D6010F
                        font-size 14rpx
                        text-align right
        .btn-wrapper
            width 100%
            position fixed
            left 0
            bottom 0
            background #ffffff
            border-top 2rpx solid rgba(240,240,240,1)
            height 60rpx
            display flex
            align-items center
            justify-content space-between
            padding-right 20rpx
            .driver-radio
                text-align center
                color #3396FB
                width 11%
                line-height 60rpx
                font-size 26rpx
                font-weight 600
                input
                    display none
                    opacity 0
            .van-button
                width 130rpx
                height 42rpx
                border-radius 21rpx
</style>